import React from 'react';

/**
 * 좋아요·댓글 줄과 댓글·답글이 같이 쓰는 아이콘 — 확정 시안(docs/ui-mockups/like-comment-bar)의 SVG 그대로.
 * 크기는 쓰는 쪽이 정한다(본문 아래 줄 22px, 댓글 아래 줄 16px, 메뉴 18px, 답글 화살표 14px). 색은 currentColor.
 */

type IconProps = React.SVGProps<SVGSVGElement>;

const HEART_PATH =
    'M12 20.5s-7.5-4.6-9.2-9.3C1.7 8.1 3.6 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.5 0 5.4 3.6 4.3 6.7-1.7 4.7-9.2 9.3-9.2 9.3z';

/** 하트(안 누름) */
export const HeartIcon: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" {...props}>
        <path fill="none" stroke="currentColor" strokeWidth={1.9} strokeLinejoin="round" d={HEART_PATH} />
    </svg>
);

/** 하트(누름) — 채움 */
export const HeartFilledIcon: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" {...props}>
        <path fill="currentColor" d={HEART_PATH} />
    </svg>
);

/** 말풍선 */
export const BubbleIcon: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" {...props}>
        <path
            fill="none"
            stroke="currentColor"
            strokeWidth={1.9}
            strokeLinejoin="round"
            d="M12 4c4.97 0 9 3.36 9 7.5S16.97 19 12 19c-1.1 0-2.15-.16-3.12-.46L4 20.5l1.4-3.6C3.9 15.5 3 13.6 3 11.5 3 7.36 7.03 4 12 4z"
        />
    </svg>
);

/** 메뉴(⋯) */
export const DotsIcon: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" {...props}>
        <circle cx="5" cy="12" r="1.8" fill="currentColor" />
        <circle cx="12" cy="12" r="1.8" fill="currentColor" />
        <circle cx="19" cy="12" r="1.8" fill="currentColor" />
    </svg>
);

/** 답글 꺾은 화살표 */
export const ReplyArrowIcon: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 24 24" aria-hidden focusable="false" {...props}>
        <path fill="none" stroke="currentColor" strokeWidth={2.2} strokeLinecap="round" strokeLinejoin="round" d="M5 4v8a4 4 0 0 0 4 4h10M15 12l4 4-4 4" />
    </svg>
);
